export function updateFiltersPageVisibility(filterId, menuFilters, pageId) {
  return menuFilters.map((filter) => {
    if (filter.uuid === filterId) {
      return removeFilterFromPage(filter, pageId);
    }

    return filter;
  });
}

function removeFilterFromPage(filter, pageId) {
  if (filter.show.length) {
    return { ...filter, show: filter.show.filter((uuid) => uuid !== pageId) };
  }

  return { ...filter, hide: [...filter.hide, pageId] };
}

/**
 * Determines if a filter is currently active for the current tab.
 * @param {Object} filter - The filter object.
 * @returns {boolean} - Whether the filter is checked.
 */
export function isFilterCheckedForCurrentTab(filter, currentTabId) {
  if (filter.show.length) {
    return filter.show.includes(currentTabId);
  }
  return !filter.hide.includes(currentTabId);
}

/**
 * Adds the current tab to the filter's applicable list.
 * @param {Object} filter - The filter object.
 * @returns {Object} - Updated filter with currentTabId included.
 */
function includeCurrentTabInFilter(filter, currentTabId) {
  const { show, hide } = filter;

  return show.length > 0
    ? { ...filter, show: [...show, currentTabId] }
    : { ...filter, hide: hide.filter((id) => id !== currentTabId) };
}

/**
 * Toggles the filter on or off for the current tab.
 * @param {Object} filter - The filter to toggle.
 * @returns {Object} - Updated filter.
 */
export function toggleFilterForCurrentTab(filter, currentTabId) {
  const isChecked = isFilterCheckedForCurrentTab(filter, currentTabId);

  return isChecked
    ? removeFilterFromPage(filter, currentTabId)
    : includeCurrentTabInFilter(filter, currentTabId);
}
